// Static company information
export const companyInfo = {
  name: "Murat Dağtekin LIHKAB",
  fullName: "Lisanslı Harita Mühendisliği Bürosu",
  license: "0401-942",
  engineer: "Murat Dağtekin",
  title: "Lisanslı Harita Mühendisi",
  authority: "Ağrı İl Genelinde Yetkili",
  phone1: "0472 215 90 36",
  phone2: "0532 694 36 90",
  email: "dagtekinm@gmail.com",
  address: "Leylekpınar Mah. 1704 Sk. Barış İş Merkezi Kat:3 No:31 Merkez AĞRI"
};

export const services = [
  {
    id: 1,
    title: "Arazi Ölçümü",
    description: "Modern teknolojik ekipmanlarla hassas arazi ölçüm hizmetleri. GPS ve Total Station cihazları ile profesyonel ölçüm.",
    icon: "Ruler"
  },
  {
    id: 2,
    title: "Aplikasyon",
    description: "Onaylı imar planlarının arazi üzerinde uygulanması ve işaretlenmesi hizmetleri.",
    icon: "MapPin"
  },
  {
    id: 3,
    title: "İfraz İşlemleri",
    description: "Parselin bölünerek ayrılması işlemleri. Tapu kayıtlarına uygun profesyonel hizmet.",
    icon: "GitBranch"
  },
  {
    id: 4,
    title: "Tevhid İşlemleri",
    description: "Birden fazla parselin birleştirilerek tek parsel haline getirilmesi işlemleri.",
    icon: "GitMerge"
  },
  {
    id: 5,
    title: "Röperli Kroki",
    description: "Referans noktalarıyla hazırlanan detaylı teknik çizimler ve ölçüm raporları.",
    icon: "FileText"
  },
  {
    id: 6,
    title: "Plankote",
    description: "İmar planı ve kullanıma ilişkin belgelerin hazırlanması ve resmi başvurular.",
    icon: "Map"
  }
];

export const faqs = [
  {
    id: 1,
    question: "LIHKAB nedir ve ne iş yapar?",
    answer: "LIHKAB (Lisanslı Harita Kadastro Bürosu), taşınmazlara ilişkin ölçüm, harita ve kadastro işlemlerini yasal yetkiyle gerçekleştiren kuruluşlardır. Arazi ölçümü, aplikasyon, ifraz, tevhid gibi işlemleri profesyonel şekilde yürütür."
  },
  {
    id: 2,
    question: "Aplikasyon işlemi nedir?",
    answer: "Aplikasyon, onaylı imar planlarının arazi üzerinde uygulanması ve işaretlenmesi işlemidir. İnşaat öncesi arsanızın sınırlarının belirlenmesi için gereklidir."
  },
  {
    id: 3,
    question: "İfraz ve Tevhid işlemleri ne kadar sürer?",
    answer: "İfraz ve tevhid işlemleri genellikle 15-30 gün içinde tamamlanır. Süre, tapu müdürlüğü iş yoğunluğuna ve belgelerin eksiksiz olmasına bağlı olarak değişebilir."
  },
  {
    id: 4,
    question: "Hangi bölgelerde hizmet veriyorsunuz?",
    answer: "Ağrı ili genelinde tam yetkili olarak hizmet vermekteyiz. Arazi ölçümü, kadastro ve tüm harita mühendisliği hizmetleri için 0401-942 lisans numarası ile çalışmaktayız."
  },
  {
    id: 5,
    question: "Randevu almak için ne yapmalıyım?",
    answer: "Telefon (0472 215 90 36 veya 0532 694 36 90) veya e-posta (dagtekinm@gmail.com) ile iletişime geçerek randevu alabilirsiniz. Web sitemizdeki iletişim formu aracılığıyla da talebinizi iletebilirsiniz."
  }
];

export const aboutInfo = {
  description: "Ağrı'da 0401-942 lisans numarası ile hizmet veren LIHKAB büromuz, tüm harita mühendisliği ve kadastro işlemlerinizde yanınızdadır. Modern teknolojik altyapımız ve deneyimli kadromuzla, arazi ölçümünden aplikasyona, ifraz-tevhid işlemlerinden plankote hazırlanmasına kadar geniş bir yelpazede profesyonel hizmet sunmaktayız.",
  engineer: {
    name: "Murat Dağtekin",
    title: "Lisanslı Harita Mühendisi",
    license: "0401-942",
    experience: "Yılların deneyimi ve modern teknolojik ekipmanlarla, Ağrı ili genelinde tüm harita mühendisliği hizmetlerinizde güvenilir ve hızlı çözümler sunuyoruz."
  }
};
